import React, { FC, useState } from 'react'

type OpenModalButtonProps = {
  ModalButton: FC<{ openModal: () => void }>
  Modal: FC<{ close: () => void }>
}

const OpenModalButton = ({ ModalButton, Modal }: OpenModalButtonProps) => {
  const [isModalVisible, setModal] = useState(false)

  return (
    <>
      <ModalButton openModal={() => setModal(true)} />
      {isModalVisible && <Modal close={() => setModal(false)} />}
    </>
  )
}

OpenModalButton.displayName = 'Modal button'

export default OpenModalButton
